"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useShades = require("./useShades");
Object.keys(_useShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useShades[key];
    }
  });
});